import React, { useEffect, useState } from 'react';

import { Grid } from "@mui/material";

import GeneralService from '../../services/general';
import { CODES } from '../../utils/responseCodes';
import { simpleAlerts } from '../../utils/alerts';
import MainSelect from './General/MainSelect';

const GroupingArea = ({
    infoCompany, setInfoCompany,
    infoClient, setInfoClient,
    infoUnit, setInfoUnit,
    infoCampus, setInfoCampus,
    infoArea, setInfoArea,
}) => {

    const [companies, setCompanies] = useState(null);
    const [clients, setClients] = useState(null);
    const [units, setUnits] = useState(null);
    const [campus, setCampus] = useState(null);
    const [areas, setAreas] = useState(null);

    useEffect(() => {
        getEmpresas();
    }, [])

    useEffect(() => {
        if (infoCompany)
            getClientesByEmpresa();
        setUnits(null);
        setCampus(null);

        setInfoClient(null);
        setInfoUnit(null);
        setInfoCampus(null);
    }, [infoCompany])

    useEffect(() => {
        if (infoClient) {
            getUnidadesByCliente();
        }
        setCampus(null);

        setInfoUnit(null);
        setInfoCampus(null);
    }, [infoClient])

    useEffect(() => {
        if (infoUnit)
            getSedesByUnidad();
        setInfoCampus(null);
    }, [infoUnit])

    useEffect(() => {
        setInfoArea(null);
        if (infoCampus)
            getAreasBySede();
    }, [infoCampus])


    const getEmpresas = async () => {
        await GeneralService.getEmpresas()
            .then(result => {
                if (result.status === CODES.SUCCESS_200) {
                    result.data?.forEach(element => {
                        element.value = element.id_empresa
                        element.label = element.desEmpresa
                        element.ruc= element.rucEmpresa
                    })
                    setCompanies(result.data);
                } else {
                    simpleAlerts('No hay información de empresas', 'info');
                }
            })
            .catch(err => {
                console.log('getEmpresas', err)
            })

    }

    const getClientesByEmpresa = async () => {
        await GeneralService.getClientesByEmpresa(infoCompany?.value)
            .then(result => {
                if (result.status === CODES.SUCCESS_200) {
                    result.data?.forEach(element => {
                        element.value = element.id_cliente
                        element.label = element.desCliente
                    })
                    setClients(result.data);
                } else {
                    simpleAlerts('No hay información de clientes', 'info');
                }
            })
            .catch(err => {
                console.log('getClientesByEmpresa', err)
            })
    }

    const getUnidadesByCliente = async () => {
        await GeneralService.getUnidadesByCliente(infoClient?.value)
            .then(result => {
                if (result.status === CODES.SUCCESS_200) {
                    result.data?.forEach(element => {
                        element.value = element.id_unidad
                        element.label = element.desUnidad
                    })
                    setUnits(result.data);
                } else {
                    simpleAlerts('No hay información de unidades', 'info');
                }
            })
            .catch(err => {
                console.log('getEmpresas', err)
            })
    }

    const getSedesByUnidad = async () => {
        await GeneralService.getSedesByUnidad(infoUnit?.value)
            .then(result => {
                if (result.status === CODES.SUCCESS_200) {
                    result.data?.forEach(element => {
                        element.value = element.id_sede
                        element.label = element.desSede
                    })
                    setCampus(result.data);
                } else {
                    simpleAlerts('No hay información de sedes', 'info');
                }
            })
            .catch(err => {
                console.log('getEmpresas', err)
            })

    }

    const getAreasBySede = async () => {
        await GeneralService.getAreasBySede(infoCampus?.value).then(result => {
            if (result.status === CODES.SUCCESS_200) {
                result.data?.forEach(element => {
                    element.value = element.id_area
                    element.label = element.desArea
            
                })
                setAreas(result.data);
            } else {
                simpleAlerts('No hay información de areas', 'info');
            }
        })
            .catch(err => {
                console.log('getEmpresas', err)
            })

    }
    /*return (
        <Grid container p={1}>
            <Grid item xs>
                <MainSelect
                    title={'Empresa'}
                    options={companies}
                    placeholder={'Selecionar Empresa'}
                    value={Number(infoCompany?.value)}
                    onChange={(value, event) => setInfoCompany(companies?.find(element => Number(element.value) === Number(value)))}
                />
            </Grid>
            <Grid item xs>
                <MainSelect
                    title={'Cliente'}
                    options={clients}
                    placeholder={'Selecionar Cliente'}
                    value={Number(infoClient?.value)}
                    onChange={(value, event) => setInfoClient(clients?.find(element => Number(element.value) === Number(value)))}
                />
            </Grid>
            <Grid item xs>
                <MainSelect
                    title={'Unidad'}
                    options={units}
                    placeholder={'Selecionar Unidad'}
                    value={Number(infoUnit?.value)}
                    onChange={(value, event) => setInfoUnit(units?.find(element => Number(element.value) === Number(value)))}
                />
            </Grid>
            <Grid item xs>
                <MainSelect
                    title={'Sede'}
                    options={campus}
                    placeholder={'Selecionar Sede'}
                    value={Number(infoCampus?.value)}
                    onChange={(value, event) => setInfoCampus(campus?.find(element => Number(element.value) === Number(value)))}
                />
            </Grid>
            <Grid item xs>
                <MainSelect
                    title={'Áreas'}
                    options={areas}
                    placeholder={'Selecionar Área'}
                    value={Number(infoArea?.value)}
                    onChange={(value, event) => setInfoArea(areas?.find(element => Number(element.value) === Number(value)))}
                />
            </Grid>
        </Grid>
    );*/

    
    return (
        <Grid container p={1}>
            <Grid item xs={12} sm={6} md={12}>
                <MainSelect
                    title={'Empresa'}
                    options={companies}
                    placeholder={'Selecionar Empresa'}
                    value={Number(infoCompany?.value)}
                    onChange={(value, event) => setInfoCompany(companies?.find(element => Number(element.value) === Number(value)))}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={6} marginTop={'0.8rem'}>
                <MainSelect
                    title={'Cliente'}
                    options={clients}
                    placeholder={'Selecionar Cliente'}
                    value={Number(infoClient?.value)}
                    onChange={(value, event) => setInfoClient(clients?.find(element => Number(element.value) === Number(value)))}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={6} marginTop={'0.8rem'}>
                <MainSelect
                    title={'Unidad'}
                    options={units}
                    placeholder={'Selecionar Unidad'}
                    value={Number(infoUnit?.value)}
                    onChange={(value, event) => setInfoUnit(units?.find(element => Number(element.value) === Number(value)))}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={6} marginTop={'0.8rem'}>
                <MainSelect
                    title={'Sede'}
                    options={campus}
                    placeholder={'Selecionar Sede'}
                    value={Number(infoCampus?.value)}
                    onChange={(value, event) => setInfoCampus(campus?.find(element => Number(element.value) === Number(value)))}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={6} marginTop={'0.8rem'}>
                <MainSelect
                    title={'Áreas'}
                    options={areas}
                    placeholder={'Selecionar Área'}
                    value={Number(infoArea?.value)}
                    onChange={(value, event) => setInfoArea(areas?.find(element => Number(element.value) === Number(value)))}
                />
            </Grid>
        </Grid>
    );
    
};

export default GroupingArea;